import {getStowAssociateMetrics, getStowPackageMetrics} from "../resources/StowResource";
import {AssociateMetric, StowPackageMetric, Resource} from "../enums";
import {CYCLE, CYCLE_ID, TOTAL} from "../constants";

export const LOAD_METRICS_FOR_ZONE_CALL_BEGIN = "LOAD_METRICS_FOR_ZONE_CALL_BEGIN";
export const LOAD_METRICS_FOR_ZONE_CALL_FAILURE = "LOAD_METRICS_FOR_ZONE_CALL_FAILURE";
export const LOAD_STOW_ASSOCIATE_METRICS_FOR_NODE = "LOAD_STOW_ASSOCIATE_METRICS_FOR_NODE";
export const LOAD_STOW_ASSOCIATE_METRICS_FOR_ZONE = "LOAD_STOW_ASSOCIATE_METRICS_FOR_ZONE";
export const LOAD_STOW_PACKAGE_METRICS_FOR_NODE = "LOAD_STOW_PACKAGE_METRICS_FOR_NODE";
export const LOAD_STOW_PACKAGE_METRICS_FOR_ZONE = "LOAD_STOW_PACKAGE_METRICS_FOR_ZONE";

const loadMetricsForZoneCallBegin = () => ({
    type: LOAD_METRICS_FOR_ZONE_CALL_BEGIN
});

const loadMetricsForZoneCallFailure = () => ({
    type: LOAD_METRICS_FOR_ZONE_CALL_FAILURE
});

const loadStowAssociateMetricsForNode = (totalStowAssociateMetrics) => ({
    type: LOAD_STOW_ASSOCIATE_METRICS_FOR_NODE,
    totalStowAssociateMetrics
});

const loadStowAssociateMetricsForZone = (stowAssociateMetricsMap) => ({
    type: LOAD_STOW_ASSOCIATE_METRICS_FOR_ZONE,
    stowAssociateMetricsMap
});

const loadStowPackageMetricsForNode = (totalStowPackageMetrics) => ({
    type: LOAD_STOW_PACKAGE_METRICS_FOR_NODE,
    totalStowPackageMetrics
});

const loadStowPackageMetricsForZone = (stowPackageMetricsMap) => ({
    type: LOAD_STOW_PACKAGE_METRICS_FOR_ZONE,
    stowPackageMetricsMap
});


export const getStowPackageMetricsForZone = (nodeId, cycles, cycleIds) => {
    return async (dispatch) => {
        try {
            dispatch(loadMetricsForZoneCallBegin());
            const request = constructStowPackageMetricsForZoneRequest(nodeId, cycles, cycleIds)
            const stowPackageMetricsMap = await getStowPackageMetrics(request);
            if (stowPackageMetricsMap) {
                dispatch(loadStowPackageMetricsForNode(getStowPackageMetricsForNode(stowPackageMetricsMap)));
                removeUnwantedZones(stowPackageMetricsMap);
                dispatch(loadStowPackageMetricsForZone(stowPackageMetricsMap));
            } else {
                dispatch(loadMetricsForZoneCallFailure());
            }
        } catch (error) {
            dispatch(loadMetricsForZoneCallFailure());
        }
    }
}


export const getStowAssociateMetricsForZone = (nodeId, cycles) => {
    return async (dispatch) => {
        try {
            dispatch(loadMetricsForZoneCallBegin());
            const request = constructStowAssociateMetricsForZoneRequest(nodeId, cycles)
            const stowAssociateMetricsMap = await getStowAssociateMetrics(request);
            if (stowAssociateMetricsMap) {
                removeUnwantedZones(stowAssociateMetricsMap);
                dispatch(loadStowAssociateMetricsForNode(getTotalMetrics(stowAssociateMetricsMap)));
                dispatch(loadStowAssociateMetricsForZone(stowAssociateMetricsMap));
            } else {
                dispatch(loadMetricsForZoneCallFailure());
            }
        } catch (error) {
            dispatch(loadMetricsForZoneCallFailure());
        }
    }
}

const constructStowAssociateMetricsForZoneRequest = (nodeId, cycles) => {
    const request = {
        groupBy: Resource.ZONE,
        filters: {
            NODE: [nodeId]
        },
        metrics: [
            AssociateMetric.ACTIVE_ASSOCIATE_COUNT,
            AssociateMetric.INACTIVE_ASSOCIATE_COUNT
        ]
    }

    cycles = cycles.filter(Boolean);
    if (cycles.length) {
        request.filters[CYCLE] = cycles;
    }
    return request
}

const constructStowPackageMetricsForZoneRequest = (nodeId, cycles, cycleIds) => {
    const request = {
        groupBy: Resource.ZONE,
        filters: {
            NODE: [nodeId]
        },
        metrics: [
            StowPackageMetric.STOW_RATE,
            StowPackageMetric.SCAN_COMPLIANCE,
            StowPackageMetric.PROBLEM_SOLVE_COUNT,
            StowPackageMetric.STOWED_COUNT,
            StowPackageMetric.CURRENT_INDUCTED_COUNT,
            StowPackageMetric.CURRENT_STOWED_COUNT
        ],
        isAggregationRequired: true
    }
    cycles = cycles.filter(Boolean);
    if (cycles.length) {
        request.filters[CYCLE] = cycles;
    }

    cycleIds = cycleIds.filter(Boolean);
    if (cycleIds.length) {
        request.filters[CYCLE_ID] = cycleIds;
    }
    return request;
}


const getTotalMetrics = (groupedMetricsMap) => {
    const totalZone = {};
    for (const Zone in groupedMetricsMap) {
        const metricsMap = groupedMetricsMap[Zone];

        for (const metric in metricsMap) {
            if (!totalZone[metric]) {
                totalZone[metric] = metricsMap[metric];
            } else {
                totalZone[metric] = +totalZone[metric] + +metricsMap[metric];
            }
        }
    }

    return {Total: totalZone};
}

const getStowPackageMetricsForNode = (stowPackageMetricsMap) => {
    return {Total: stowPackageMetricsMap[TOTAL]}
}

const removeUnwantedZones = (metricsMap) => {
    delete metricsMap[TOTAL];
}


// WEBPACK FOOTER //
// ./src/actions/ZoneActions.js